export default __webpack_public_path__ + "static/media/redshiftlogo.396ddd74.png";